/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Shipping_AdjustmentsInputs */

const en_nav_shipping_adjustments = /** @type {(inputs: Nav_Shipping_AdjustmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping Adjustments`)
};

const es_nav_shipping_adjustments = /** @type {(inputs: Nav_Shipping_AdjustmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes de envio`)
};

/**
* | output |
* | --- |
* | "Shipping Adjustments" |
*
* @param {Nav_Shipping_AdjustmentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_shipping_adjustments = /** @type {((inputs?: Nav_Shipping_AdjustmentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Shipping_AdjustmentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_shipping_adjustments(inputs)
	return es_nav_shipping_adjustments(inputs)
});